import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { getMyVisions } from '../../actions/planningAction';
import PlanningSideQuests from './PlanningSideQuests';
import '../UserPortal/PlanCard.css';

const MS_IN_DAY = 1000 * 60 * 60 * 24;

function PlanningVisionCard({ vision }) {
  const { _id, title, timeframe, createdAt, nodeCount } = vision;

  const totalDays  = timeframe * 365;
  const daysPassed = Math.floor((Date.now() - new Date(createdAt)) / MS_IN_DAY);
  const daysLeft   = Math.max(totalDays - daysPassed, 0);
  const progress   = Math.min((daysPassed / totalDays) * 100, 100);

  const theme =
    timeframe === 1 ? 'theme-1y' :
    timeframe === 3 ? 'theme-3y' : 'theme-5y';

  const formatDate = (d) =>
    new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <Link to={`/dashboard/planning/${_id}`} className={`plan-card ${theme}`}>
      <div className="plan-header">
        {timeframe === 5 && <span className="plan-p5-badge">PROJECT-5</span>}
        <h3>{title}</h3>
        <span className="plan-duration-tag">{timeframe} Year Vision</span>
      </div>

      <p className="plan-started">
        Started on <strong>{formatDate(createdAt)}</strong>
      </p>

      <div className="plan-meta">
        <span>{nodeCount ?? 0} nodes</span>
        <span>{daysLeft} days left</span>
      </div>

      <div className="progress-track">
        <div className="progress-fill" style={{ width: `${progress}%` }} />
      </div>
    </Link>
  );
}

export default function PlanningHome() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { visions, loading } = useSelector(s => s.planning);
  const [tab, setTab] = useState('visions');

  useEffect(() => {
    dispatch(getMyVisions());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="dashboard-top-row">
        <div className="top-left">
          <div className="view-toggle">
            <button className={tab === 'visions' ? 'active' : ''} onClick={() => setTab('visions')}>My Visions</button>
            <button className={tab === 'sidequests' ? 'active' : ''} onClick={() => setTab('sidequests')}>Side Quests</button>
          </div>
        </div>
        {tab === 'visions' && (
          <div className="top-right">
            <button
              className="pv-new-btn"
              onClick={() => navigate('/dashboard/planning/new')}
            >
              <span className="pv-new-btn-plus"></span> New Vision
            </button>
          </div>
        )}
      </div>

      {tab === 'visions' ? (
        <div className="my-plans-section">
          {loading && visions.length === 0 ? (
            <div style={{ padding: '2rem 1rem', color: '#9ca3af', fontSize: '0.85rem' }}>Loading…</div>
          ) : visions.length === 0 ? (
            <div style={{ padding: '3rem 1rem' }}>
              <p style={{ color: '#9ca3af', marginBottom: '1rem' }}>No visions yet.</p>
              <button
                className="pv-new-btn"
                onClick={() => navigate('/dashboard/planning/new')}
              >
                <span className="pv-new-btn-plus">+</span> Start your first vision
              </button>
            </div>
          ) : (
            <div className="plans-grid">
              {visions.map(v => (
                <PlanningVisionCard key={v._id} vision={v} />
              ))}
            </div>
          )}
        </div>
      ) : (
        <PlanningSideQuests />
      )}
    </div>
  );
}
